import React from "react";
import { Form, Typography } from "antd";

import { StyledDescriptions } from "../../_common/styles";
import { formatPrice } from "helperFunctions";

interface Props {
  name: string;
  currency: string;
}

const Preview: React.FC<Props> = ({ name, currency }) => {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const value = getFieldValue(name);

        return (
          <StyledDescriptions bordered column={2} layout="vertical">
            <StyledDescriptions.Item style={{ width: "20%" }}>Amount</StyledDescriptions.Item>
            <StyledDescriptions.Item>
              <Typography.Text>{value ? `${formatPrice(value)} ${currency}` : "Not Defined"}</Typography.Text>
            </StyledDescriptions.Item>
          </StyledDescriptions>
        );
      }}
    </Form.Item>
  );
};

export default Preview;
